module.exports = __webpack_public_path__ + "static/before-2-bdac4806d3d48f74b4d16c27d8392579.png";